module.exports = __webpack_public_path__ + "static/media/map_2-3.e9edc6d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/map_2-3.svg
// module id = 761
// module chunks = 0